export const BRAND = "brand";
export const CHANNEL = "channel";
export const PARTNER_TYPE = "partnerType";
export const PARTNER = "partner";
export const NAME = "name";
export const STATUS = "status";

export const ADDRESS = "address";
export const CITY = "city";
export const STATE = "state";
export const ZIP = "zip";

export const CHANNEL_BRANCH = "channel_branch";
export const MARKETER_BRANCH = "marketer_branch";
export const STATE_BRANCH = "state_branch";
export const BRANCH = "branch";
